import {
  Directive,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { BaseDialog } from '@core/services/overlay/overlay.model';
import { Subject, takeUntil } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Directive()
export abstract class AbstractBaseDialogComponent
  implements BaseDialog, OnDestroy, OnInit
{
  private router = inject(Router);
  @Output() closeRequested = new EventEmitter();
  @Output() submittedSuccessfully: EventEmitter<void> = new EventEmitter();

  public componentDestroyed: Subject<void> = new Subject();

  ngOnInit() {
    // Close dialog when the route changes
    this.router.events
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((events) => {
        if (events instanceof NavigationStart) {
          this.closeRequested.emit();
        }
      });
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.complete();
  }
}
